import { X } from 'lucide-react';
import { useTreeStore } from '@/store/useTreeStore';
import { PersonDetail } from './PersonDetail';

// ─── PersonPanel ────────────────────────────────────────────────────────────
//
// Rechte Seitenleiste mit Personendetails.
// Wird in AppLayout als bedingtes Element gerendert.
// Animation via CSS transition (translate-x).

export function PersonPanel() {
  const selectedPersonId = useTreeStore((s) => s.selectedPersonId);
  const setSidebarOpen = useTreeStore((s) => s.setSidebarOpen);

  if (!selectedPersonId) return null;

  return (
    <>
      {/* Abdunkelung hinter dem Panel – nur solange es als Overlay erscheint
          (Handy + Tablet-Hochformat). Tap daneben schließt das Panel. */}
      <div
        className="fixed inset-0 z-[1290] bg-black/40 lg:hidden"
        onClick={() => setSidebarOpen(false)}
        aria-hidden="true"
      />

      <aside
        className="fixed inset-y-0 right-0 z-[1300] flex w-full max-w-md flex-col bg-white shadow-2xl
                   lg:static lg:inset-auto lg:z-auto lg:w-[380px] lg:max-w-none lg:shrink-0
                   lg:border-l lg:border-slate-200 lg:shadow-none"
        style={{
          animation: 'slideInRight 0.2s ease-out',
          paddingTop: 'env(safe-area-inset-top)',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
      {/* Header */}
      <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <h2 className="text-sm font-semibold text-slate-900">Person-Details</h2>
        <button
          onClick={() => setSidebarOpen(false)}
          className="rounded p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
          aria-label="Sidebar schließen"
        >
          <X className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>

      {/* Person-Detail-Inhalt */}
      <div className="flex-1 overflow-y-auto">
        <PersonDetail personId={selectedPersonId} />
      </div>

      {/* CSS-Animation */}
      <style>{`
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
      </aside>
    </>
  );
}
